module.exports = __webpack_public_path__ + "img/study_1.1e1b0c40.png";